import { Badge } from "@mantine/core";
import { STATE, type BadgeStateKey } from "../../theme/mantine-theme";

/**
 * A workflow state, as a pill.
 *
 * Driven ENTIRELY by the theme's state map and it does not accept a colour.
 * That is the point of it: a screen cannot tint a badge to taste, so the same
 * status is the same colour everywhere, and adding a status means adding it
 * to the theme where somebody can see the whole set at once.
 *
 * COLOUR NEVER CARRIES THE MEANING. Every badge renders its label, because a
 * red pill means nothing to someone who cannot distinguish it from the green
 * one, and because "red" is not a status - "Rejected" is.
 */
export function StateBadge({
  state,
  label,
  size = "sm",
}: {
  state: BadgeStateKey;
  /** Overrides the theme's label. For a status whose wording is contextual. */
  label?: string;
  size?: "xs" | "sm" | "md";
}) {
  const token = STATE[state];
  return (
    <Badge
      size={size}
      radius="sm"
      styles={{
        root: {
          backgroundColor: token.bg,
          color: token.fg,
          // The design is border-led; a badge reads as a filled chip, so it
          // carries no border of its own.
          border: "none",
        },
      }}
    >
      {label ?? token.label}
    </Badge>
  );
}
